module.exports = __webpack_public_path__ + "static/img/menu-logo.3a5db8b8.png";